import axios from '@/axios'
const login = {
  //获取腾讯APPID  /validateAppId
  async getAppId(params = '') {
    return await axios.post('/validateAppId', params, {
      des: '直客pc获取腾讯APPID',
      sTime: new Date().getTime(),
    })
  },
  // customer
  async login(params) {
    return await axios.post('/uc/login', params, {
      des: '直客pc登录',
      sTime: new Date().getTime(),
    })
  },
  // switch
  async switch(params) {
    return await axios.post('/uc/switch', params, {
      des: '直客pc切换账户类型',
      sTime: new Date().getTime(),
    })
  },
  // 获取资金权限
  async getGoldPageList(params) {
    return await axios.post('/uc/goldPage/jfGoldPageList', params, {
      des: '直客pc获取资金权限',
      sTime: new Date().getTime(),
    })
  },
  // 验证资金权限
  async checkGoldPageList(params) {
    return await axios.post('/uc/goldPage/jfGoldPageStatus', params, {
      des: '直客pc验证资金权限',
      sTime: new Date().getTime(),
    })
  },
  //找回密码API
  //验证姓名手机号
  async queryName(params) {
    return await axios.post('/queryNamePassword', params, {
      des: '直客pc验证姓名手机号',
      sTime: new Date().getTime(),
    })
  },
  //找回密码发送验证码
  async pwdCode(params) {
    return await axios.post('/queryPasswordCode', params, {
      des: '直客pc回密码发送验证码',
      sTime: new Date().getTime(),
    })
  },
  //找回密码发送验证码  发送类型（1：手机 2：邮箱）
  async pwdCode(params) {
    return await axios.post('/queryPasswordCode', params, {
      des: '直客pc回密码发送验证码',
      sTime: new Date().getTime(),
    })
  },
  //修改密码
  async submitNewPwd(params) {
    return await axios.post('/queryPassword', params, {
      des: '直客pc修改密码',
      sTime: new Date().getTime(),
    })
  },
  //登出
  async logout(params) {
    return await axios.post('/uc/logout', params, {
      des: '直客pc登出',
      sTime: new Date().getTime(),
    })
  },
  //是否绑定模拟账号
  async bindAccount(params) {
    return await axios.post('/uc/user/bindAccount/infoByMobile', params, {
      des: '直客pc登出',
      sTime: new Date().getTime(),
    })
  },
}

export default login



// WEBPACK FOOTER //
// ./src/api/login.js